import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AuthModule } from './auth/auth.module';
import { UserModule } from './user/user.module';
import { WorklistModule } from './worklist/worklist.module';
import { TemplateModule } from './template/template.module';
import { SettingsModule } from './settings/settings.module';
import { ClientModule } from './client/client.module';
import { ConfigServiceService } from './config-service.service';
import { DataService } from './data.service';
import { FormsModule } from '@angular/forms';
import { QueueModule } from './queue/queue.module';
// import { AutomatedRemitReportComponent } from './reports/automated-remit-report/automated-remit-report.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    AuthModule,
    UserModule,
    WorklistModule,
    TemplateModule,
    SettingsModule,
    QueueModule,
    ClientModule,
    FormsModule,
  ],
  providers: [ConfigServiceService, DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }
